<div class="modal-body p-4">
    <h1 *ngIf="displayState == 0">Member Login</h1>
    <h1 *ngIf="displayState == 1">Reset Password</h1>
    <div id="login" *ngIf="displayState == 0">
        <form [formGroup]="loginForm" (keyup.enter)="login()">
          <fieldset class="form-group">
            <div class="form-floating">
              <input type="text" class="form-control form-control-lg" formControlName="userName" autofocus placeholder="" />
              <label><i class="fa-regular fa-envelope me-1"></i> Email Address</label>
            </div>
          </fieldset>
          <fieldset class="form-group mt-3">
            <div class="form-floating">
              <input type="password" class="form-control form-control-lg" id="password" placeholder=""
           formControlName="password" autocomplete="off" />
              <label><i class="fa-regular fa-lock me-1"></i> Password</label>
            </div>
          </fieldset>
          <fieldset class="mt-4">
            <button type="button" [disabled]="loginForm.invalid || isBusy" (click)="login()" class="btn btn-lg btn-secondary w-100 mb-2">Sign In</button>
            <button type="button" (click)="toSignUp()"class="btn btn-lg btn-primary w-100">Become a Member</button>
            <div class="text-center mt-3">
              <a class="text-link-blue" id="forgot-password-link" (click)="displayState = 1" href="javascript:void(0)"><small>forgot your password?</small></a>
            </div>
          </fieldset>
        </form>
      </div>


      <!-- Reset Password -->
      <div id="reset-password" *ngIf="displayState == 1">
        <div class="loginMessage">
          <div class="messageText">
            Forgot your password? No worries! Enter your email address below, and we'll send you a link to reset your password. Check your inbox and follow the instructions. If you don't receive the email within a few minutes, please check your spam folder.
          </div>
        </div>
        <form [formGroup]="resetForm" (keyup.enter)="forgotPassword()">
          <fieldset class="form-group">
            <div class="form-floating">
              <input type="text" class="form-control form-control-lg" placeholder="" formControlName="userName" autofocus />
              <label><i class="fa-regular fa-envelope me-1"></i> Email Address</label>
            </div>
          </fieldset>
          <fieldset class="mt-4">
            <button (click)="forgotPassword()" [disabled]="resetForm.invalid || isBusy" type="button" class="btn btn-lg btn-secondary w-100 mb-2">
              Send Reset
              Link
            </button>
          </fieldset>
        </form>
        <div class="login-links mt-3">
          <a class="text-link-blue" (click)="displayState = 0" id="login-back-link" href="javascript:void(0)">
            <i class="far fa-arrow-left"></i> back to
            login
          </a>
        </div>
      </div>
</div>